(() => {
  const configElement = document.getElementById('bf-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const ids = new Set(config.productIds.map(String));
  let pending = Promise.resolve();
  async function syncGift() {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}});
    if (!response.ok) throw new Error('Could not check gift eligibility');
    const cart = await response.json();
    const count = cart.items.reduce((sum, item) => sum + (ids.has(String(item.product_id)) ? item.quantity : 0), 0);
    const value = count >= 2 ? config.giftValue : '';
    if ((cart.attributes['Black Friday gift'] || '') !== value) {
      const update = await fetch(root + 'cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({attributes: {'Black Friday gift': value}})});
      if (!update.ok) throw new Error('Could not record free gift');
    }
    return cart;
  }
  window.rimalBlackFriday = {
    sync() {
      pending = pending.catch(() => {}).then(syncGift);
      return pending;
    }
  };
  window.rimalBlackFriday.sync().catch(() => {});
  document.addEventListener('submit', async (event) => {
    if (!event.submitter || event.submitter.name !== 'checkout' || event.target.dataset.bfReady === 'true') return;
    event.preventDefault();
    const form = event.target;
    const button = event.submitter;
    button.disabled = true;
    try {
      await window.rimalBlackFriday.sync();
      form.dataset.bfReady = 'true';
      button.disabled = false;
      form.requestSubmit(button);
    } catch {
      button.disabled = false;
      const error = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
      if (error) error.textContent = window.cartStrings?.error || 'Please try again.';
    }
  }, true);
})();
